import { Download, ShieldCheck, ArrowRightLeft } from "lucide-react";

const STEPS = [
  { icon: Download, title: "Download PamaPay", body: "Grab the app from the App Store or Google Play. Sign up with email in under 30 seconds." },
  { icon: ShieldCheck, title: "Complete verification", body: "Quick KYC with your BVN and ID. Takes 2-3 minutes and unlocks instant withdrawals." },
  { icon: ArrowRightLeft, title: "Convert & cash out", body: "Send crypto, lock the rate, and receive Naira in your bank — usually in under a minute." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-white" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-xs uppercase tracking-[0.2em] text-[#3B6FBF] font-bold mb-4">
            Three steps
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05] text-slate-900" data-testid="how-it-works-title">
            Enjoy PamaPay in a few steps.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 relative">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="relative rounded-3xl border border-slate-200 bg-white p-7 md:p-8 hover:shadow-[0_10px_40px_-15px_rgba(15,23,42,0.15)] transition-all"
                data-testid={`step-card-${i}`}
              >
                <div className="font-display font-black text-7xl text-[#3B6FBF]/10 absolute top-4 right-5 leading-none select-none">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="relative">
                  <div className="w-12 h-12 rounded-2xl bg-[#3B6FBF] flex items-center justify-center text-white mb-5">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="text-xs uppercase tracking-wider text-slate-500 mb-2 font-mono-data">Step {i + 1}</div>
                  <h3 className="font-display font-bold text-xl mb-2 text-slate-900">{s.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{s.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
